import { render, staticRenderFns } from "./about-of-user-info.html?vue&type=template&id=4ef232f2&scoped=true&external"
import script from "./about-of-user-info.js?vue&type=script&lang=js&external"
export * from "./about-of-user-info.js?vue&type=script&lang=js&external"
import style0 from "./about-of-user-info.scss?vue&type=style&index=0&id=4ef232f2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef232f2",
  null
  
)

export default component.exports